import React from "react";
import DateRangeReport from "../../../components/DateRangeReport";
import Select from "react-select";

const DashboardFilters = ({ onChangeDate, onChangeStore, store, range }) => {
  return (
    <div className="row mb-2">
      <div className="col-sm-4" style={{ maxWidth: "max-content" }}>
        <DateRangeReport onChange={onChangeDate} field="tran_date" />
      </div>
      <div className="col-sm-4">
        <Select
          options={[
            { value: "AllStore", label: "All Store" },
            ...store.map((code) => ({
              value: code.name,
              label: code.name,
            })),
          ]}
          onChange={(option) => onChangeStore(option?.value)}
          isDisabled={!range}
        />
      </div>
    </div>
  );
};

export default DashboardFilters;
